import React from "react";
import { Link } from "react-router-dom";

const footerStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@300;400;500;600&display=swap');
  .pmfoot { font-family: 'Syne', sans-serif; }
  .pmfoot-root {
    background: linear-gradient(160deg, #2E4A2A 0%, #3A5050 50%, #2E4458 100%);
    padding: 1.75rem 2.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 1rem;
    position: relative;
  }
  .pmfoot-root::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 2px;
    background: linear-gradient(90deg, #4E8A3C, #7BBCC8);
  }
  .pmfoot-brand { font-size: 13px; font-weight: 500; color: rgba(255,255,255,0.85); }
  .pmfoot-brand span { color: #7BBF6A; font-style: normal; }
  .pmfoot-badge {
    display: flex; align-items: center; gap: 8px;
    background: rgba(255,255,255,0.07);
    border: 1px solid rgba(200,223,194,0.2);
    border-radius: 6px; padding: 7px 14px;
  }
  .pmfoot-badge span {
    font-size: 10px; letter-spacing: 1.5px; text-transform: uppercase;
    color: #C9A96E;
  }
  .pmfoot-links { display: flex; gap: 20px; flex-wrap: wrap; }
  .pmfoot-links a {
    font-size: 11px; color: rgba(255,255,255,0.35);
    text-decoration: none; letter-spacing: 0.3px;
    transition: color 0.2s; cursor: pointer;
  }
  .pmfoot-links a:hover { color: #7BBF6A; }
  .pmfoot-copy { font-size: 10px; color: rgba(255,255,255,0.2); letter-spacing: 0.3px; }
`;

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: footerStyles }} />
      <footer className="pmfoot">
        <div className="pmfoot-root">
          <div className="pmfoot-brand">ProMed <span>Health+</span></div>

          <div className="pmfoot-badge">
            <span>HQAA Certified Provider</span>
          </div>

          <div className="pmfoot-links">
            <Link to="/about">About</Link>
            <Link to="/how-it-works">How It Works</Link>
            <Link to="/products">Products</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms">Terms & Conditions</Link>
          </div>

          <div className="pmfoot-copy">© {year} ProMed Health Plus LLC · Westlake Village, CA</div>
        </div>
      </footer>
    </>
  );
};

export default Footer;